<script>
  import { createEventDispatcher, onDestroy } from "svelte";
  import { stored } from "../../stores/stores";

  let dispatch = createEventDispatcher();

  // *** stores ***
  let tooltipFn = $stored.tooltip;
  let tooltipHideFn = $stored.tooltipHide;
  let button;
  
  // *** exports ***

  export let id;
  export let command;

  // *** vars ***
  let toolButtonClass =
    "p-1 rounded bg-slate-100 hover:bg-slate-200 text-slate-600 font-bold mx-0.5";


  function handleClick(event) {
    // скрываем tooltip
    button.blur();
    dispatch("click", event);

  }
</script>

<button
  tabindex="-1"
  {id}
  class={toolButtonClass}
  data-bs-toggle="tooltip"
  data-bs-placement="bottom"
  data-bs-custom-class="custom-tooltip"
  data-bs-title={command?.name +
    " " +
    "(" +
    command.shortcutEn.toUpperCase() +
    ")"}
  use:tooltipFn
  on:click={handleClick}
  bind:this={button}
>
  <slot name="icon"></slot>
</button>

<style>

</style>
